export const boxDocumentStyles = (isBusy, hasFile) => ({
  width: '100%',
  minHeight: 80,
  borderRadius: '10px',
  bgcolor: '#f3f3f7',
  px: 2,
  py: 2,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  opacity: isBusy ? 0.85 : 1,
  pointerEvents: isBusy ? 'none' : 'auto',
  '&:hover': {
    bgcolor: hasFile ? '#f3f3f7' : '#e0e0e0',
  },
});

export const notSelectedFileTypographyStyles = {
  fontSize: '12px',
  color: '#b5b5b5',
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  ml: 1,
  flexShrink: 0,
};

export const selectedFileTypographyStyles = {
  fontSize: '12px',
  color: '#6d6d6d',
  lineHeight: 1.2,
  whiteSpace: 'nowrap',
  ml: 1,
  flexShrink: 0,
};
